<template>
  <div :class="$vuetify.breakpoint.mdAndUp ? 'px-12 my-12' : 'px-2 my-4'">
    <v-snackbar class="pa-0" light timeout="-1" v-model="alertShow" width="fit-content" top centered>
      <v-alert
        v-model="alertShow"
        dismissible
        :icon="alertSuccess ? 'check_circle' : 'cancel'"
        class="mb-0 pa-1"
        :class="alertSuccess ? 'profile-alert-success' : 'profile-alert-failed'"
        light
        close-icon="close"
      >
        {{ alertMessage }}
      </v-alert>
    </v-snackbar>
    <!--    desktop-->
    <v-card elevation="0" class="justify-space-around referralLayout hidden-sm-and-down">
      <v-img :src="bannerSrc" :aspect-ratio="newBannerLive ? 1920 / 400 : 1820 / 420">
        <div class="fill-height">
          <v-row no-gutters align="end" class="fill-height">
            <v-col v-if="!newBannerLive" cols="7" class="text-center">
              <label class="white--text font-weight-bold text-uppercase referral-banner-title" style="font-size: 2.1rem; margin-top: 20px;">{{ $t(`label.referralProgram`) }}</label>
              <p class="white--text subtitle-1" style="margin:0px; font-size: 1.0rem!important;">
                {{ $t(`label.referralProgramText1`) }}
              </p>
              <p class="white--text subtitle-1" style="margin:0px; font-size: 1.0rem!important;">
                {{ $t(`label.referralProgramText2`) }}
              </p>
              <p class="white--text subtitle-1" style="font-size: 1.0rem!important;">
                {{ $t(`label.referralProgramText3`) }}
              </p>
              <label class="white--text font-weight-bold text-uppercase referral-banner-title" style="font-size: 2.1rem;">{{ $t(`label.referralFriendWillGet`) }}</label>
              <p class="white--text subtitle-1" style="font-size: 1.0rem!important;">
                {{ $t(`label.referralFriendWillGetText`) }}
              </p>
            </v-col>
            <v-col cols="12" class="text-right">
              <v-btn elevation="0" class="referral-tab" to="tier" active-class="primary" depressed @click="selectedTab = 'inbox'">{{ $t(`button.referralTier`) }}</v-btn>
              <v-btn elevation="0" class="referral-tab" to="summary" active-class="primary" depressed @click="selectedTab = 'announcement'">{{ $t(`button.summary`) }}</v-btn>
              <v-btn elevation="0" class="referral-tab" to="report" active-class="primary" depressed @click="selectedTab = 'inbox'">{{ $t(`button.referralReport`) }}</v-btn>
              <v-btn elevation="0" class="referral-tab" to="history" active-class="primary" depressed @click="selectedTab = 'announcement'">{{ $t(`button.redeemHistory`) }}</v-btn>
            </v-col>
          </v-row>
        </div>
      </v-img>
      <v-card-text v-if="isLoggedIn || currentRouteName == 'tier'" class="referralContainer">
        <router-view></router-view>
      </v-card-text>
      <v-card-text v-else class="referralContainer">
        <v-row v-if="!isLoggedIn">
          <v-col cols="12" class="text-center">
            <label color="title_color2">{{ $t(`message.referralNoLogin`) }}</label>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn height="auto" @click="openLoginDialog" color="title_color" class="mr-6 primary-button embedded-login-button pa-2 font-weight-bold referral-login-btn subtitle-1">
              {{ $t(`button.login`) }}
            </v-btn>
            <app-button
              :customClass="'buttonPrimary subtitle-1 full-width font-weight-bold pa-2 theme-button referral-register-button embedded-register-button'"
              :action="openRegisterDialog"
              :title="$t(`label.signUp`)"
            ></app-button>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- mobile -->
    <v-card elevation="0" class="justify-space-around referralLayout hidden-md-and-up">
      <v-img :src="bannerSrcMobile" :aspect-ratio="newBannerLive ? 828 / 368 : 1820 / 420">
        <div v-if="!newBannerLive" class="fill-height d-flex align-center justify-center text-center">
          <div style="background: rgba(0,0,0,0.45); border-radius: 8px; padding: 10px 14px;">
            <label class="white--text font-weight-bold d-block referral-banner-title-mobile">{{ $t(`label.referralProgram`) }}</label>
            <p class="white--text subtitle-2" style="margin:0px; font-size: 0.7rem!important;">{{ $t(`label.referralProgramText1`) }}</p>
            <p class="white--text subtitle-2" style="margin:0px; font-size: 0.7rem!important">{{ $t(`label.referralProgramText2`) }}</p>
            <p class="white--text subtitle-2" style="margin:0px 0px 10px 0px; font-size: 0.7rem!important">{{ $t(`label.referralProgramText3`) }}</p>
            <label class="white--text font-weight-bold d-block referral-banner-title-mobile">{{ $t(`label.referralFriendWillGet`) }}</label>
            <p class="white--text subtitle-2" style="margin:0px; font-size: 0.7rem!important">{{ $t(`label.referralFriendWillGetText`) }}</p>
          </div>
        </div>
      </v-img>
      <v-row class="mobile-header referral no-gutters">
        <v-col cols="6" class="text-center mobile-header-item" :class="$route.name == routeName.REFERRAL_TIER ? 'selected' : ''" @click="naviToTier">
          <router-link :to="routeName.REFERRAL_TIER" style="text-decoration: unset !important">
            <span>{{ $t(`mobileMenuTitle.myReferral`) }}</span>
          </router-link>
        </v-col>
        <v-col cols="6" class="text-center mobile-header-item" :class="$route.name == routeName.REFERRAL_SUMMARY ? 'selected' : ''" @click="naviToSummary">
          <router-link :to="routeName.REFERRAL_SUMMARY" style="text-decoration: unset !important">
            <span>{{ $t(`mobileMenuTitle.myReferralCom`) }}</span>
          </router-link>
        </v-col>
      </v-row>
      <v-card-text v-if="isLoggedIn || currentRouteName == 'tier'" class="referralContainer">
        <router-view></router-view>
      </v-card-text>
      <v-card-text v-else class="referralContainer">
        <!--        desktop before login view-->
        <v-row v-if="!isLoggedIn" class="hidden-sm-and-down">
          <v-col cols="12" class="text-center">
            <label color="title_color2">{{ $t(`message.referralNoLogin`) }}</label>
          </v-col>
          <v-col cols="12" class="text-center hidden-sm-and-down">
            <v-btn height="auto" @click="openLoginDialog" color="title_color" class="mr-6 primary-button embedded-login-button pa-2 font-weight-bold subtitle-1 referral-login-btn">
              {{ $t(`button.login`) }}
            </v-btn>
            <app-button
              :customClass="'buttonPrimary subtitle-1 full-width font-weight-bold pa-2 theme-button embedded-register-button'"
              :action="openRegisterDialog"
              :title="$t(`label.signUp`)"
            ></app-button>
          </v-col>
          <v-col cols="12" class="text-center hidden-md-and-up">
            <v-btn @click="this.openLoginDialog" color="title_color" class="mr-1 primary-button embedded-mobile-login-button font-weight-bold yellow--text">{{ $t(`button.login`) }}</v-btn>
            <app-button :customClass="'buttonPrimary theme-button embedded-mobile-register-button'" :action="this.openRegisterDialog" :title="$t(`label.signUp`)"></app-button>
          </v-col>
        </v-row>
        <!--        mobile beforeLogin view-->
        <v-card class="mobile-refLayout-before-login-card hidden-md-and-up">
          <!--          <v-col cols="6">{{ $t(`message.referralNoLogin`) }}</v-col>-->
          <!--          <v-card-subtitle>{{ $t(`message.referralNoLogin`) }}</v-card-subtitle>-->
          <v-row no-gutters>
            <v-col cols="12" class="mobile-beforeLogin-text">{{ $t(`message.referralNoLogin`) }}</v-col>
            <v-col cols="12">
              <v-row style="flex-direction: column;gap: 1rem;">
                <v-col cols="7" class="mx-auto inpage-before-login-first text-center beforeLoginBtn" @click="goToRegisterPage()">
                  <b>{{ $t(`label.register`) }}</b>
                </v-col>
                <v-col cols="7" class="mx-auto  inpage-navigator-before-login-second text-center beforeLoginBtn" @click="goToLoginPage()">
                  <b>{{ $t(`label.login`) }}</b>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <!--            <v-card-subtitle cols="12">{{ $t(`message.referralNoLogin`) }}</v-card-subtitle>-->
          <!--        <v-btn>signup</v-btn>-->
          <!--          <v-btn>login</v-btn>-->
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ReferralSummary from '@/assets/svg/referral-summary.svg'
import ReferralHistory from '@/assets/svg/referral-history.svg'
import ReferralReport from '@/assets/svg/referral-report.svg'
import ReferralTier from '@/assets/svg/referral-tier.svg'
import moment from 'moment'
import { uiHelper, locale } from '@/util'
import { ROUTE_NAME } from '@/constants/route.constants'
// import ReferralTier from './referralTier.vue'
// import ReferralSummary from './referralSummary.vue'
// import ReferralReport from './referralReport.vue'
// import ReferralHistory from './referralHistory.vue'
export default {
  name: 'referralLayout',
  components: {
    ReferralSummary,
    ReferralHistory,
    ReferralReport,
    ReferralTier
  },
  metaInfo: {
    title: `${locale.getMessage('meta.default_title')}`,
    titleTemplate: `%s | ${uiHelper.getHost()}`,
    meta: [{ charset: 'utf-8' }, { name: 'description', content: `${locale.getMessage('meta.default_description')}` }, { name: 'keyword', content: `${locale.getMessage('meta.default_keyword')}` }]
  },
  data: () => ({
    selectedTab: 'tier',
    alertShow: false,
    alertSuccess: false,
    alertMessage: '',
    routeName: ROUTE_NAME
  }),
  computed: {
    // ST001663: new banners (copy baked into the image, bd/en) go live 2026-09-15 00:00 BD (GMT+6).
    // Before that, keep the old image + i18n text overlay. Drop the gate + old assets after go-live.
    newBannerLive() {
      return moment().isSameOrAfter('2026-09-15T00:00:00+06:00')
    },
    bannerLang() {
      return this.$i18n.locale === 'bd' ? 'bd' : 'en'
    },
    bannerSrc() {
      const current = this.newBannerLive ? `/static/image/referral/referral_banner_${this.bannerLang}.jpg` : '/static/image/referral/referral_banner.jpg'
      return uiHelper.pageBanner(current, '/static/image/referral/referral_banner_202610')
    },
    bannerSrcMobile() {
      const current = this.newBannerLive ? `/static/image/referral/referral_banner_mobile_${this.bannerLang}.jpg` : '/static/image/referral/referral_banner_mobile.jpg'
      return uiHelper.pageBanner(current, '/static/image/referral/referral_banner_mobile_202610')
    },
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    currentRouteName() {
      return this.$route.name
    }
  },
  watch: {
    alertShow() {
      if (!this.alertShow) {
        this.alertSuccess = false
        this.alertMessage = ''
      }
    }
  },
  methods: {
    goToRegisterPage() {
      this.$router.push({
        name: ROUTE_NAME.REGISTER
      })
    },
    goToLoginPage() {
      this.$router.push({
        name: ROUTE_NAME.LOGIN
      })
    },
    naviToTier() {
      this.$router.push({
        name: ROUTE_NAME.REFERRAL_TIER
      })
    },
    naviToSummary() {
      this.$router.push({
        name: ROUTE_NAME.REFERRAL_SUMMARY
      })
    },
    openLoginDialog() {
      this.$parent.openLoginDialog()
    },
    openRegisterDialog() {
      this.$parent.openRegisterDialog()
    },
    openAlert(success, msg) {
      this.alertSuccess = success
      this.alertMessage = msg
      this.alertShow = true
    }
  }
}
</script>

<style lang="scss">
.referral-banner-title {
  display: block;
  font-size: 1.1rem;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.referral-banner-title-mobile {
  font-size: 1rem;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.referral-register-button {
  color: white !important;
}

.referral-login-btn {
  color: #fff !important;
}
.mobile-refLayout-before-login-card.v-card {
  background-color: #1d1d1d;
  text-align: center;
  display: flex;
  height: 170px;
  margin-left: 25px;
  margin-right: 25px;
  border-radius: 10px;
  color: #ffffff;

  .beforeLoginBtn {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
  }
  .inpage-before-login-first {
    color: white;
    background-color: var(--v-newMobilePrimary-base);
    border-radius: 15px;
    height: 50px;
  }

  .inpage-navigator-before-login-second {
    color: black;
    background-color: var(--v-newMobileSecondary-base);
    border-radius: 15px;
    height: 50px;
  }
  .v-card__subtitle {
    color: #ffffff;
  }

  .mobile-beforeLogin-text {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.mobile-header.referral {
  background-color: var(--v-newMobileSecondaryDarker-base);
  color: #000;
  height: 50px;
  .mobile-header-item {
    display: flex;
    justify-content: center;
    align-items: center;
    &.selected {
      background: radial-gradient(80.17% 665.36% at 17.36% 30.95%, #848a2b 0%, #435131 100%);
      border-bottom: 5px solid var(--v-newMobilePrimary-base);
      color: var(--v-newMobileSecondary-base);
    }
  }
}
.profile-alert-success {
  .v-icon {
    color: #25b34b;
  }
}
.profile-alert-failed {
  .v-icon {
    color: #dc2d2d;
  }
}
.referralLayout {
  border-radius: 20px !important;
  .referralContainer {
    border: 1px solid #ebebeb;
    padding: 36px 16px;
  }
  .referral-tab {
    width: 150px;
    margin-right: 16px;
    padding: 10px;
    background-color: #fff;
    text-transform: capitalize;
    letter-spacing: 0px !important;
  }
  .referral-tab-mobile {
    margin-right: 10px;
    background-color: #fff;
    text-transform: capitalize;
    padding: 0px 10px !important;
    letter-spacing: 0px !important;
  }
  .mobile-nav-active {
    background-color: var(--v-primary-base) !important;
    color: #fff !important;
    font-size: 14px;
    span {
      word-break: break-all;
      white-space: pre-line;
    }
    .mobile-icon {
      fill: #fff !important;
      path {
        fill: #fff !important;
      }
    }
  }
}
.mobile-referral-expansion {
  .v-expansion-panel {
    background-color: transparent !important;
    .v-expansion-panel-header {
      .v-expansion-panel-header__icon {
        i {
          color: #fff !important;
        }
      }
    }
  }
}
@media (max-width: 959px) {
  .embedded-mobile-login-button {
    width: 70px !important;
    height: 30px !important;
    font-size: 12px !important;
  }
  .embedded-mobile-register-button {
    width: 90px !important;
  }
}
@media (max-width: 425px) {
  .referralLayout {
    border-radius: 20px !important;
    .referralContainer {
      border: 1px solid #ebebeb;
      padding: 16px 4px;
    }
    .referral-tab-mobile {
      margin-right: 5px;
      background-color: #fff;
      text-transform: capitalize;
      padding: 0px 5px !important;
      letter-spacing: 0px !important;
    }
    .mobile-nav-active {
      background-color: var(--v-primary-base) !important;
      color: #fff !important;
      font-size: 12px;
    }
  }
}
</style>
